export default __webpack_public_path__ + "879f774dff473ca0728952223a847e66.png";